import { createAsyncThunk } from "@reduxjs/toolkit";
import apiConfig from "constants/apiConfig";
import { fetchCampaignPerformance as fetchCampaignPerformanceAPI } from "services/api/campaign";
import { AuthState } from "slices/auth/reducer";
import { ERROR } from "types";
import { CampaignPerformanceData, CampaignPerformanceSlice } from "types/campaign/performance";
import { getErrorMessage, isFresh } from "utils/helpers";

export const fetchCampaignPerformance = createAsyncThunk<{ campaignId: string, campaignPerformance: CampaignPerformanceData, isDefault: boolean }, { campaignId: string, force?: boolean, payload?: any }, { rejectValue: string }>(
    'campaign/performance',
    async ({ campaignId, force, payload }, { getState, rejectWithValue }) => {
        try {

            const state = getState() as { auth: AuthState, campaignPerformance: CampaignPerformanceSlice };
            const agencyId = state.auth.selectedAgencyId;
            if (!agencyId) throw new Error("No agency selected!");

            const STALE_TIME = apiConfig.FETCH_CAMPAIGN_PERFORMANCE.staleTime;

            const defaultDateRange = state.campaignPerformance.default_date_range;

            if (!force && !payload && defaultDateRange && isFresh(state.campaignPerformance.campaigns[campaignId]?.[defaultDateRange]?.last_fetched_at ?? null, STALE_TIME)) {
                return rejectWithValue(ERROR.CACHED);
            }

            const campaignPerformance = await fetchCampaignPerformanceAPI(agencyId, campaignId, payload);

            return { campaignId, campaignPerformance, isDefault: !(!!payload) }

        } catch (error) {
            return rejectWithValue(getErrorMessage(error, "Failed to fetch campaign performance data!"));
        }
    }
)